PF.List.Add = class Add extends PF.Trait
	{
	initTrait()
		{
		this.dom.add.show();
		this.dom.add.on('click', () => this.addItem());
		}

	addItem()
		{
		this.creatingModel = this.models.createNewItem(this.newItemData);
		this.creatingModel.isNewRecord = true;
		let item = PF.H.create(this.itemClass, {index: undefined, list: this, model: this.creatingModel}, this.creatingModel);
		this.creatingModel.listItem = item;
		item.popup.open();

		this.creatingModel.once('save-success', () => this.creatingModel.trigger('save-add'));
		this.creatingModel.once('save-local', () => this.creatingModel.trigger('save-add'));

		this.creatingModel.once('save-add', () => this.addComplete(this.creatingModel));
		}

	addComplete(model)
		{
		if (this.addTo === 'begin')
			{
			this.models.unshift(model);
			}
		if (this.addTo === 'end')
			{
			this.models.push(model);
			}
		// this.models.trigger('changed');
		}
	};